export const language = {
	field: '',
	lastUpdated: 'Last Updated:',
};
